<template>
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 13L7 8L1 13" stroke="currentColor" stroke-linecap="round"/>
        <path d="M13 6L7 1L1 6" stroke="currentColor" stroke-linecap="round"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGScrollUp',
};
</script>

<style scoped lang="scss">

</style>
